import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '向美而行，以美育人|重庆2022美育双百佳示范案例推选活动';
const baseUrl = '20220816MYSBJ';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homelist',
      name: `${baseUrl}-homelist`,
      component: () => import('./pages/HomeList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeDetail',
      name: `${baseUrl}-homeDetail`,
      component: () => import('./pages/HomeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
